import React from "react";
import { Container, Grid } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartColumn } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import "moment/locale/es";
import { PageHeader } from "../../components/base";
import HomeInfo from "./HomeInfo";
import ChartDia from "./homeInfoComponents/ChartDia";

import MoraByGestor from "./homeInfoComponents/MoraByGestor";
import ClientsByLocation from "./clientComponents/ClientsByLocation";
import CreditsByPeriodicidad from "./clientComponents/CreditsByPeriodicidad";
import ColocacionSemanal from "./homeInfoComponents/ColocacionSemanal";

// "miércoles, 1 de octubre de 2026", con la primera letra en mayúscula.
const fechaDeHoy = () => {
  const texto = moment().locale("es").format("dddd, D [de] MMMM [de] YYYY");
  return texto.charAt(0).toUpperCase() + texto.slice(1);
};

const HomeContainer = () => {
  return (
    <Container maxWidth={false} disableGutters>
      <PageHeader
        titulo="Resumen general"
        subtitulo={fechaDeHoy()}
        icono={<FontAwesomeIcon icon={faChartColumn} />}
      />

      <HomeInfo />

      {/* Primero lo del día (cobrado y mora por gestor), luego la colocación y al final el reparto
          de la cartera. En pantallas anchas van tres gráficos por fila; en las medianas, dos. */}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} lg={6} xl={4}>
          <ChartDia />
        </Grid>

        <Grid item xs={12} lg={6} xl={4}>
          <MoraByGestor />
        </Grid>

        <Grid item xs={12} xl={4}>
          <ColocacionSemanal />
        </Grid>

        <Grid item xs={12} md={6}>
          <CreditsByPeriodicidad />
        </Grid>

        <Grid item xs={12} md={6}>
          <ClientsByLocation />
        </Grid>
      </Grid>
    </Container>
  );
};

export default HomeContainer;
